export default function getVendorSharingUrl(slug: string): string {
  if (process.env.NEXT_PUBLIC_GOVLAUNCH_ENV === "production") {
    return `https://${slug}.vendors.govlaunch.com`;
  }

  if (process.env.NEXT_PUBLIC_GOVLAUNCH_ENV === "qa") {
    return `https://${slug}.vendors.qa.govlaunch.com`;
  }

  return `http://localhost:3006?vendor=${slug}`;
}
